import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function PaulHopper() {
  const paulHopperSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Paul Hopper",
    "jobTitle": "Chairman",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/paul-hopper"
  };

  return (
    <div className="boardOfDirectorsBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Paul Hopper - Chairman"
        description="Paul Hopper has over 25 years of experience in biotech, healthcare and life sciences with a focus on start-up and rapid growth companies."
        keywords={['Paul Hopper', 'Chairman', 'Biotech Leadership', 'Healthcare', 'Life Sciences']}
        ogImage="/paulHopper.webp"
        schema={paulHopperSchema}
      />

      <div className="page-width px-20 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[3.8rem]" aria-label="Breadcrumb">
          <Link to="/leadership/board-of-directors" className="text-white hover:text-primary-red transition-colors">
            Board of Directors
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Paul Hopper</span>
          </div>
        </nav>

        <div className="flex flex-col gap-4 md:gap-16 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Paul Hopper
          </div>
          <div className="text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Chairman
          </div>
        </div>
      </div>

      <div className="pt-[130px] xl:pt-[90px] xl:pb-[80px] page-width">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/paulHopper.webp" 
                alt="Paul Hopper, Chairman: Expert in Growth of Biotech, Healthcare and Life Sciences Companies" 
                className="w-full" 
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="text-[2rem] leading-[3.6rem] tracking-[0.8px] font-normal text-left text-white">
                Paul Hopper has over 25 years of experience in biotech, healthcare and life sciences with a focus on start-up and rapid growth companies. He has served as either Founder, Chairman, non-executive director, or CEO, for more than 15 companies in the US, Australia and Asia.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="paul-hopper" 
        basePath="/leadership" 
      />
    </div>
  );
}